import { Urls } from 'system/urls';
import history from 'system/history';

class RouteManager extends Urls {
  root = '/';

  registerRoutes(urls) {
    Object.assign(this.urls, urls);
    this.initializeUrls();
    return this;
  }

  setRoot(root) {
    this.root = root;
    return this;
  }

  setBaseRoute(baseRoute) {
    this.baseRoute = baseRoute;
    return this;
  }
}

const routeManager = new RouteManager({});

export default routeManager;

export const getValueFromQueryString = (key) => {
  const query = window.location.search;

  if (!query) {
    return '';
  }

  const searchText = (
    query.substr(1)
      .split('&')
      .map((part) => {
        const splitPart = part.split('=');
        return {
          key: splitPart[0],
          value: decodeURIComponent(splitPart[1])
        };
      })
      .filter(keyValuePair => keyValuePair.key === key)
  )[0];

  if (!searchText || typeof searchText !== 'object') {
    return '';
  }

  return searchText.value;
};

export function setValueToQueryString(route, query, options = {}) {
  let url = routeManager[route].params(options);

  url = url.query(query);

  history().loadUrl(`/${url.toString()}`);
}
